import React, { useEffect, useState } from 'react'
import { IPageComponentProps } from './Interfaces'

import { useAppDispatch, useAppSelector } from '../../app/hooks';
import AuthService, { isRefreshTokenExpired, updateAuthLocalStorage } from '../auth/AuthService';
import windowLocationRedirect from '../redirect';
import UserService, { IUserModel } from '../../services/user';
import { useDispatch } from 'react-redux';
import { currentUserDetails, updateUser } from '../user/userSlice';
import UnauthorizedBlock from '../../components/UnauthorizedBlock';
import { handleRequestError } from '../../services/api';
import { useLocation } from 'react-router-dom';
import UserSideModal from '../user/UserSideModal';
import Register2FA from '../auth/Register2FA';
import ProtectedPage from './ProtectedPage';

export default function ProtectedRoute(props: IPageComponentProps) {

    const { page } = props
    
    return <ProtectedPage isAdminOnly={page.isAdminOnly ? true : false} redirectIfUnauthorized={true}><props.page.component page={page}/></ProtectedPage>
}

// export default function ProtectedRoute(props: IPageComponentProps) {

//     const dispatch = useDispatch()
//     const location = useLocation()

//     const { isAuthenticated, tokenRefreshedTime } = useAppSelector((state) => state.auth)
//     const user = useAppSelector((state) => state.user.details)

//     const [isUnauthorized, setIsUnauthorized] = useState<boolean>(false)
//     const [resgister2FA, setRegister2FA] = useState<boolean>(false)

//     const { page } = props
//     const isAdminOnly = page.isAdminOnly

//     const [unauthorizedMessage, setUnauthorizedMessage] = useState<{ title: string, message: string }>({ title: "", message: "" })

//     /**
//      * Verify token
//      */

//     const sendRequestToVerifyToken = () => {
//         AuthService.verifyAccessToken()
//             .then(response => {
//                 // token is valid
//             })
//             .catch(error => {
                
//                 const status = error.response.status
//                 // const message = error.response.data.message ? error.response.data.message : "Error"

//                 switch(status){

//                     case 401:
//                         AuthService.refreshAccessToken()
//                             .then(response => {
//                                 // console.log("success", response)
//                                 updateAuthLocalStorage()
//                             })
//                             .catch(error => {
//                                 console.log("error", error)
//                                 // windowLocationRedirect("sign-in?back=" + window.location.pathname + window.location.search)
//                                 windowLocationRedirect("logout?back=" + window.location.pathname + window.location.search)
//                             })
//                         break

//                     default:
//                         windowLocationRedirect("logout")
//                 }

//             })
//     }

//     const verifyToken = () => {
//         if (!isRefreshTokenExpired()){
//             sendRequestToVerifyToken()
//         }
//     }

//     /**
//      * Load user details
//      */
//     const loadUserDetails = () => {
//         UserService.getCurrentUserData()
//             .then(response => {
//                 dispatch(updateUser(response))
//             })
//             .catch(error => {

//                 const { response } = error
//                 const status = response.status

//                 switch(status){

//                     case 403:
//                         setRegister2FA(true)
//                         break

//                     case 404:
//                         setIsUnauthorized(true)
//                         setUnauthorizedMessage({ title: "No Access", message: response.data.message ? response.data.message : "Your account has been deleted" })
//                         break

//                     case 406:
//                         setIsUnauthorized(true)
//                         setUnauthorizedMessage({ title: "No Access", message: response.data.message ? response.data.message : "Your account has been blocked" })
//                         break

//                     case 409:
//                         setIsUnauthorized(true)
//                         setUnauthorizedMessage({ title: "No Access", message: response.data.message ? response.data.message : "You have to re-login to your account. Because your password has been changed" })
//                         break

//                     case 410:
//                         setIsUnauthorized(true)
//                         setUnauthorizedMessage({ title: "No Access", message: response.data.message ? response.data.message : "Your password is expired. You have to update it" })
//                         break     
                                         
//                     case 411:
//                         setIsUnauthorized(true)
//                         setUnauthorizedMessage({ title: "You're Blocked", message: response.data.message ? response.data.message : "Your account has been banned" })
//                         break      

//                     default:
//                         handleRequestError(error, dispatch)
//                 }

//             })
//     }

//     /**
//      * Refresh Token
//      */
//     useEffect(() => {
//         sendRequestToVerifyToken()
        
//         loadUserDetails()
        
//         setInterval(() => {
//             verifyToken()
//         }, 10000)
//     }, [])

//     /**
//      * Update user details if page is changed
//      */
//     useEffect(() => {
//         loadUserDetails()
//     }, [location.pathname])

//     // useEffect(() => {
//     //     if (isAuthenticated){
//     //         setIsUnauthorized(true)
//     //     }else[
//     //         setIsUnauthorized(false)
//     //     ]
//     // }, [isAuthenticated])

//     /**
//      * Check user
//      */
//     useEffect(() => {

//         let access: boolean = true
//         let title: string = ""
//         let message: string = ""

//         if (isAdminOnly){
//             if (!user.is_superuser){
//                 access = false
//             }
//         }

//         /**
//          * Check if user blocked
//          */
//         if (user.is_blocked){
//             access = false
//             title = "No Access"
//             message = "Your account has been blocked"
//         }

//         if (!access){
//             setIsUnauthorized(true)
//             setUnauthorizedMessage({ title: title, message: message })
//         }else{
//             setIsUnauthorized(false)
//             setUnauthorizedMessage({ title: "", message: "" })
//         }
//     }, [user])

//     /**
//      * 2FA
//      */
//     if (resgister2FA){
//         return(
//             <div className="login-page-container">
//                 <div className="content-of-login-page-container">
//                     <Register2FA />
//                 </div>
//             </div>
//         )
//     }

//     /**
//      * If not authenticated
//      */
//     if (isUnauthorized){
//         return <UnauthorizedBlock title={unauthorizedMessage.title} message={unauthorizedMessage.message} />
//     }

//     if (!isAuthenticated){
//         return <UnauthorizedBlock />
//     }

//     return(
//         <div>
//             <UserSideModal />
//             <props.page.component page={page} />
//         </div>
//     )
// }